module.exports = __webpack_public_path__ + "img/2na1-na-pulce.95dea16c.jpg";